import * as React from 'react';
import { Tab } from 'semantic-ui-react';
import { Identifiable, DataClass } from 'src/shared/utility';
import { observer } from 'mobx-react';
import GenericDataStorage from 'src/stores/application/generic/datastore';

export type ActionButton = {
    icon: string;
    callback: () => void;
};

export type ActionMenu = {
    icon: string;
    actions: {
        icon: string;
        text: string;
        callback: () => void;
    }[];
};

interface TabGridProps<T extends Identifiable, C extends DataClass> {
    dataStore: GenericDataStorage<T, C>;

    presets?: Array<any>;
    defaultValue?: Function | any;

    filter: (v: any) => boolean;
    sort?: any;
    nameGen: (v: any) => string;
    renderer: ( props: any) => JSX.Element;  
    stagingPanel?: (props: any) => any;
    [keys: string]: any;
}

interface TabGridState {
    resolveCallback: any;
    awaitingSave: boolean;   
}

@observer
export default class TabGrid < 
    T extends Identifiable, 
    C extends DataClass 
> extends React.Component<
    TabGridProps<T, C>, 
    TabGridState
> {
    awaitingChange = false;
    isEditing = false;
    items: Array<any>;
    orderedItems: {
        hasChanged: boolean;
        order: Array<any>;
    } = {
        hasChanged: true,
        order: []
    };

    constructor(props: TabGridProps<T, C>) {
        super(props);
    }

    render(): JSX.Element {
        const { dataStore, sort } = this.props;
        let _sort;
        if (typeof(sort) === 'function' ) {
            _sort = sort;
        } else {
            _sort = (() => { return 0; });
        }
        const items = dataStore.getParsedItems as C[];
        let flatableReleventItems = items.filter(this.props.filter)
            .sort(_sort);

        let releventItems = flatableReleventItems.flatten ? 
            flatableReleventItems.flatten() : 
            flatableReleventItems as C[];
        
        let isFirst = !(Array.isArray(releventItems) && releventItems.length > 0);

        let result = [
            ...releventItems.map((item, index)  => { 
                return {
                    menuItem: this.props.nameGen(item),
                    render: this.props.renderer.bind(this, { 
                        ...this.props,
                        value: item,
                        key: index,
                        isFirst,
                        awaitingSave: this.state ? this.state.awaitingSave : false
                    })
                };
            })
        ];

        if (this.props.stagingPanel) {
            let staging =  this.props.stagingPanel({
                ...this.props,
                isFirst,
                value: typeof this.props.defaultValue === 'function' ? 
                    this.props.defaultValue(this.props)
                    : this.props.defaultValue,
                key: 'add-new',
                awaitingSave: this.state ? this.state.awaitingSave : false
            });

            if (staging) {
                result.push(staging);
            }
        }
        
        return (
            
            <Tab 
                panes={result}
            />
        );
    }  
}


// WEBPACK FOOTER //
// ./src/components/generic/GenericStoreTabs.tsx